import DOMPurify from "dompurify";
import "./RichTextEditor.css";

/**
 * Render rich-text HTML safely. Strips dangerous tags/attributes.
 */
export default function RichTextView({ html, className = "" }) {
  if (!html) return null;
  // If the value doesn't look like HTML (plain text), preserve line breaks.
  const looksLikeHtml = /<\w+[^>]*>/.test(html);
  // Replace non-breaking spaces (NBSP) with regular spaces so long lines wrap
  // normally on mobile. Copy-paste from Word/Quill often inserts &nbsp; between
  // every word which prevents wrapping entirely.
  const dewrapped = (looksLikeHtml ? html : html.replace(/\n/g, "<br/>"))
    .replace(/&nbsp;/gi, " ")
    .replace(/\u00a0/g, " ");
  const safe = DOMPurify.sanitize(dewrapped, looksLikeHtml ? { USE_PROFILES: { html: true } } : undefined);
  return (
    <div
      className={`rte-content ${className}`}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
